const tickerItems = [
  "评分口径对上不上的那一行",
  "临时更换的评委名单",
  "同分为什么不同命",
  "举牌到念名字的十二秒",
  "纸质分与电子分谁说了算",
  "凌晨两点的赛后通稿",
];

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="overflow-hidden border-y border-background-200 bg-secondary-100">
      <div className="flex items-center">
        <span className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 font-label text-xs font-semibold tracking-wide text-background-50 md:px-6">
          <i className="ri-radar-line" aria-hidden="true"></i>
          正在深扒
        </span>
        <div className="relative flex-1 overflow-hidden py-3">
          <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap pl-6 text-sm text-secondary-900">
            {loop.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center gap-8">
                {item}
                <i className="ri-circle-fill text-[6px] text-primary-400" aria-hidden="true"></i>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}